import script from "./DateInformationTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./DateInformationTooltip.vue?vue&type=script&setup=true&lang=js"

import "./DateInformationTooltip.vue?vue&type=style&index=0&id=1c126e54&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c126e54"]])

export default __exports__